// extracted by mini-css-extract-plugin
export default {"section":"Notes_section__gyxZn","grid":"Notes_grid__HuT6e"};